import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import { SEVERITY_META } from '@/features/schema/severity'
import type { ConceptDefinition } from '@/services/api/schemas'

export function ConceptCard({ id, concept }: { id: string; concept: ConceptDefinition }) {
  const { t } = useTranslation()
  const meta = SEVERITY_META[concept.severity]
  return (
    <div className="border-border rounded-md border p-3 text-sm">
      <div className="flex flex-wrap items-center gap-2">
        <Badge className={meta.badgeClass}>{t(meta.labelKey)}</Badge>
        <span className="font-mono text-xs">{id}</span>
        <span className="text-muted-foreground text-xs">
          {t('schemaAgent.editor.concept.on', { attachment: concept.attachment })}
        </span>
        {concept.effect.view.length > 0 && (
          <span className="text-muted-foreground text-xs">→ {concept.effect.view.join(', ')}</span>
        )}
      </div>
      <div className="mt-2 font-medium">{concept.title}</div>
      <div className="text-muted-foreground mt-1 text-xs">{concept.summary}</div>
      {concept.requires.length > 0 && (
        <div className="text-muted-foreground mt-2 text-xs">
          <span className="font-medium">{t('schemaAgent.editor.concept.requires')} </span>
          {concept.requires.map(r => (
            <code key={r} className="bg-muted ml-1 rounded px-1 py-0.5">
              {r}
            </code>
          ))}
        </div>
      )}
    </div>
  )
}
